import { useLoaderData, useNavigate } from "react-router-dom"

import BlankLayout from "layouts/blank-layout"
import BranchRadio from "components/forms/branch-radio"

import { Branch } from "components/icons/outline"
import { useEffect, useState } from "react"
import { useAuth } from "contexts/auth-context"
import nProgress from "nprogress"
import { lang } from "config"

const SelectBranch = ({ title }) => {
    const { setCurrentBranch, logout } = useAuth()

    const [branch, setBranch] = useState({})

    const navigate = useNavigate()
    const data = useLoaderData()

    // Satu cabang saja → tidak perlu memilih; langsung set dan lanjut.
    // Dedupe per id: API bisa mengembalikan 1 baris per kombinasi cabang×role,
    // jadi user 1 cabang dengan 2 role tetap terhitung satu cabang.
    useEffect(() => {
        const list = Array.isArray(data) ? data : (data?.data ?? [])
        const unique = []
        list.forEach((b) => {
            if (b && !unique.some((u) => String(u.id) === String(b.id))) unique.push(b)
        })

        if (unique.length === 1) {
            setCurrentBranch(unique[0])
            navigate(0, { replace: true })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSelect = (e) => {
        nProgress.start()
        e.preventDefault()

        setCurrentBranch(branch)

        navigate(0, { replace: true })
        nProgress.done()
    }

    const handleLogout = (e) => {
        e.preventDefault()
        logout()
        // Hard redirect — lihat catatan di user-dropdown (navigate(0) tidak reliable utk logout).
        window.location.replace("/")
    }

    return (
        <BlankLayout title={title}>
            <div className="flex items-center justify-center w-full px-4 py-12 sm:px-6 lg:px-8">
                <div className="w-full max-w-md space-y-8">
                    <div>
                        <div className="flex justify-center">
                            <div className="p-4 text-white rounded-full bg-brand-800">
                                <Branch className="w-8 h-8" />
                            </div>
                        </div>
                        <h2 className="mt-6 text-3xl font-bold tracking-tight text-center text-gray-900">
                            {lang.select_branch}
                        </h2>
                        <p className="mt-2 text-sm text-center text-neutral-600">
                            {lang.in_order_to_continue_please_select}
                        </p>
                    </div>
                    <div className="mt-8 space-y-6">
                        <BranchRadio onChange={(value) => setBranch(value)} selection={data} />
                        <div className="space-y-3">
                            <button onClick={handleSelect} disabled={!branch} className={`${!branch ? 'bg-neutral-600' : 'bg-brand-800 active:hover:scale-90'} items-center w-full px-6 py-3 text-sm text-white transition rounded-xl`}>
                                <span>{lang.select}</span>
                            </button>
                            <button onClick={handleLogout} type="button" className="items-center w-full px-6 py-3 text-sm transition border border-neutral-300 text-neutral-700 rounded-xl active:hover:scale-90 hover:bg-neutral-100">
                                <span>Keluar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </BlankLayout>
    )
}

export default SelectBranch